// THE SINGLE MODE DECISION FOR THE WHOLE APP.
//
// Fleet is always served over HTTPS; a direct single-ARC session is always
// served by arc_gateway over PLAIN HTTP on port 80. So the scheme alone is the
// discriminator, and there is no hostname list to maintain.
//
// This used to sniff the host against an IP-literal regex plus a fixed list
// (`offlinemode`, `localhost`, `offline.r2c2.ai`). That broke the moment an
// operator reached the ARC by any other name — the app silently classified a
// direct session as fleet mode and tried to talk to a fleet backend that isn't
// there. arc_gateway now answers on every hostname, so the host tells us
// nothing and the scheme tells us everything.
//
// DEV NOTE: fleet development served over http://localhost:3000 would classify
// as DIRECT by this rule. Set REACT_APP_IS_ONLINE_MODE=true in .env.local for
// fleet dev — the explicit override below always wins.
import { isHttpSecure } from "lib/utils/utils";

export const isForceOnlineMode = ["true", "false"].includes(process.env.REACT_APP_IS_ONLINE_MODE);

export const isOnlineMode = isForceOnlineMode
    ? JSON.parse(process.env.REACT_APP_IS_ONLINE_MODE)
    : isHttpSecure();
